<template>
  <div>
    <div class="pdfok" id="pdfok" v-if="pdfok"></div>
    <div v-if="dataover222" id="printMe" style=" width: 21cm; margin: 0 auto;">
      <div v-if="report_type == 1" v-for="(item, index) in reportData" :key="index">
        <Yuebao :info1="item" :idx="index" :stuinfo="stuInfo" :pmid="pmid"></Yuebao>
        <YuebaoKPI v-if="pmid != 208" :info="item"></YuebaoKPI>
      </div>
      <div v-if="report_type == 0" v-for="(item, index) in reportData" :key="index + 'a'">
        <Zhoubao :info1="item" :idx="index" :stuinfo="stuInfo"></Zhoubao>
      </div>
    </div>




    <!--    <el-button v-print="'#printMe'" type="primary" style="position: fixed;top: 60px;right: 10px;z-index: 999;">-->
    <!--      打印-->
    <!--    </el-button>-->

  </div>
</template>

<script>
import Yuebao from './com_stu/yuebao'
import YuebaoKPI from './com_stu/yuebao_kpi'
import Zhoubao from './com_stu/zhoubao'

export default {
  name: 'export',
  components: {
    Zhoubao,
    Yuebao,
    YuebaoKPI,
  },
  data() {
    return {
      pdfok: false,
      show_dev: false,
      show_dev1: false,
      dataover222: true,
      showIdentify: false,
      printObj: {
        id: 'printMe',
        popTitle: '',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      userid: '',

      stuInfo: {},
      yuebao: [{}],
      zhoubao: [{}],
      chinaCitys: [],
      // 填入导出的pdf文件名和html元素
      pdfTitle: '试卷1',
      pdfSelector: '#printMe',
      pmid:'',
      report_type: '',
      reportData: [],
    }
  },
  mounted() {
    let id = this.getParams('id')
    let pmid = this.getParams('pmid')
    let reportType = this.getParams('report_type')
    let year = this.getParams('y')
    let month = this.getParams('m')
    let week = this.getParams('n')
    // let id = 'fd05786013204a96ae7586c9cd77a32a'
    this.pmid = pmid
    this.report_type = reportType
    console.log(1111111, id, pmid)
    this.getDataList(id, pmid,reportType,year,month,week)

  },
  methods: {
    //过滤特殊字符, 校验所有输入域是否含有特殊符号
    stripscript(s) {
      var pattern = new RegExp('[&mdash;]')
      var rs = ''
      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '-')
      }
      return rs
    },
    findDeep(list, iid) {
      for (let i in list) {
        if (list[i].value === iid) {
          return [list[i]]
        }
        if (list[i].children != null) {
          let node = this.findDeep(list[i].children, iid);
          if (node !== undefined) {
            return node.concat(list[i])
          }
        }
      }

    },
    getDataList(stu_id, pmid,reportType,y,m,n) {
      let _this = this
      this.$http.post('/api/stu_month_week_report', {
        stu_id: parseInt(stu_id) ? parseInt(stu_id) : stu_id,
        pmid: parseInt(pmid),
        report_type: reportType,
        report_year: y,
        report_month:m,
        number: n
      }).then(res => {
        if (res.data) {
          this.reportData = res.data.report_data;
          this.stuInfo = res.data.stu_info;
        }

        this.$nextTick(() => {
          setTimeout(() => { _this.pdfok = true }, 500)
        })

      })

    },

    getParams(name) {
      let n_url = window.location.href
      n_url = n_url.replace('/#', '')
      if (n_url.indexOf('?') > 0) {
        n_url = n_url.split('?')[1]
      }
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = n_url.match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    //分割数组 arr：原数组  num：分割后每个数组里的数据条数
    util_spliceArrByN(arr, num) {
      var _arr = []
      while (arr.length) {
        _arr.push(arr.splice(0, num))
      }
      return _arr
    },
    //数组按某属性分组
    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    }
  }
}
</script>
<style lang="less" type="text/less">
@import "/public/css/pdf_default";
</style>
